<template>
  <div class="editGallery">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        闲置交换详情
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="flush()">刷新</div>
        </div>
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
      <div class="filtrate_head">
        <div class="filtrate_filer">闲置交换详情</div>
      </div>
      <div class="table">
        <el-form
          :label-position="labelPosition"
          label-width="100px"
          style="padding-top:30px; margin: 0 auto"
        >
          <el-form-item label="商品名称:">
            <el-input v-model="title" disabled></el-input>
          </el-form-item>
          <el-form-item label="商品图片:">
            <div style="display:flex;">
              <div
                style="width:80px;height:68px;margin-left:10px;    border: 1px solid #c0c4cc;"
                v-for="item in img"
                :key="item.id"
              >
                <el-popover placement="bottom" width="500" trigger="hover">
                  <p>
                    <img width="500" height="300" :src="serve+'/'+item" alt />
                  </p>
                  <img
                    slot="reference"
                    :src="serve+'/' + item "
                    width="80"
                    height="68"
                    alt
                  />
                </el-popover>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="品牌:">
            <el-input v-model="brand" disabled></el-input>
          </el-form-item>
          <el-form-item label="所属分类:">
            <el-input v-model="category" disabled></el-input>
          </el-form-item>
          <el-form-item label="数量:">
            <el-input v-model="number" disabled></el-input>
          </el-form-item>
          <el-form-item label="规格:">
            <el-input v-model="specification" disabled></el-input>
          </el-form-item>
          <el-form-item label="价格:">
            <el-input v-model="selling_price" disabled></el-input>
          </el-form-item>
          <el-form-item label="是否出售:">
            <template>
              <el-radio v-model="is_sell" label="1" disabled>是</el-radio>
              <el-radio v-model="is_sell" label="0" disabled>否</el-radio>
            </template>
          </el-form-item>

          <el-form-item label="详细内容:">
            <div class="audit_div">
              <p class="audit_div_icon" @click="browse()">
                <i class="fas fa-cloud-download-alt"></i>
                下载到本地
              </p>
              <p class="audit_div_p3">在线预览</p>
            </div>
          </el-form-item>

          <el-form-item label="商品详情:">
            <textarea name id="tetx" v-model="info" placeholder="请输入内容" disabled></textarea>
          </el-form-item>
          <el-form-item label="备注:">
            <textarea name id="tetx" v-model="remark" placeholder="请输入内容"></textarea>
          </el-form-item>

          <el-form-item style="padding-bottom:200px">
            <el-button type="primary" @click="submit1()" :disabled="show">未通过</el-button>
            <el-button type="success" @click="submit()" :disabled="show">通过审核</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { serve: this.$store.state.serve,
      username: "",
      token: "",
      radio: "1",
      title: "",
      img: [],
      brand: "",
      category: "",
      number: "",
      specification: "",
      selling_price: "",
      is_sell: "",
      info: "",
      remark: "",
      show: false,
      ///////////////////
      options1: [],
      value1: "",

      labelPosition: "right",

      content: "",
      class_id: "",
      newImage: null,
      id: this.$route.params.id,
      imagss: ""
    };
  },
  created() {
    this.$store.state.topActiveId = 4;
    this.$store.state.leftTitle = "闲置交换审核";
    this.getting();
  },
  methods: {
    imagess(v) {
      this.imagss = v.target.currentSrc;
    },
    getting() {
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      if (this.token === this.token) {
        this.axios
          .get(this.serve+"/admin/exchange_detail", {
            params: {
              username: this.username,
              token: this.token,
              id: this.id
            }
          })
          .then(res => {
            var json = res.data.data;
            that.title = json.title;
            var imgs = json.images;

            that.img = json.images.split(";");

            that.brand = json.brand;
            that.category = json.category;
            that.number = json.number;
            that.specification = json.specification;
            that.selling_price = json.selling_price;
            that.is_sell = json.is_sell;
            that.info = json.info;
            that.remark = json.remark;
            if (json.check != "0") {
              this.show = true;
            }
            // that.content = json.content;
            // that.value1 = json.class;
          });
      }
    },
    getImage(e) {
      this.newImage = e.target.files[0];
    },
    open4() {
      //错误时返回的息状态
      this.$message.error("添加失败");
    },
    open() {
      this.$message({
        //成功时 返回的状态
        message: "已通过",
        type: "success"
      });
    },
    open1() {
      this.$message({
        //成功时 返回的状态
        message: "拒绝成功",
        type: "success"
      });
    },
    submit() {
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");

      if (this.remark == "") {
        this.$message({
          message: "备注不能为空",
          type: "warning"
        });
        return;
      }
      this.axios
        .get(this.serve+"/admin/submit_exchange", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id,
            check: 1,
            remark: this.remark
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            that.$router.push({ path: "./y_exchange" });
          }
        });
    },
    submit1() {
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");

      if (this.remark == "") {
        this.$message({
          message: "备注不能为空",
          type: "warning"
        });
        return;
      }
      this.axios
        .get(this.serve+"/admin/submit_exchange", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id,
            check: 2,
            remark: this.remark
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.open();
            that.$router.push({ path: "./y_exchange" });
          }
        });
    }
  }
};
</script>
<style lang="scss">
.editGallery {
  #tetx {
    width: 580px;
    height: 250px;
  }
  .audit_div {
    display: flex;
    align-items: center;
    height: 60px;
    .audit_div_icon {
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      color: #c0c4cc;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 40px;
      width: 190px;
      padding-left: 10px;

      cursor: pointer;
    }
    .audit_div_p1 {
      font-size: 14px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
    }

    .audit_div_p3 {
      margin-left: 4px;
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      cursor: pointer;
    }
    .audit_div_p3:hover {
      color: rgba(51, 51, 51, 1);
    }
  }
  background: #f5f5f5;
  color: #333;
  min-height: 1000px;
  .filtrate_head {
    width: 100%;
    .filtrate_filer {
      height: 46px;
      width: 1040px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }
    .filtrate_seek {
      position: relative;
      font-size: 16px;
      // border-bottom: 1px solid rgba(221, 221, 221, 1);
      border-left: 1px solid rgba(221, 221, 221, 1);
      border-right: 1px solid rgba(221, 221, 221, 1);
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      height: 86px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      // margin: 24px 0 0 17px;
      display: flex;
      align-items: center;
      background: #fff;
      > strong {
        font-size: 16px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-left: 24px;
        margin-right: 6px;
      }
      .filtrate_seek_sousuo {
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        font-family: "MicrosoftYaHeiLight";
        font-weight: 300;
        color: rgba(102, 102, 102, 1);
        width: 74px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        position: absolute;
        right: 18px;
        top: 29px;
        cursor: pointer;
      }
      .filtrate_seek_sousuo:hover {
        color: #0099ff;
      }
    }
    .el-input__inner {
      // height: 28px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }

  textarea {
    height: 300px;
  }
  .form-title {
    background-color: #eee;
    border: 1px solid #ddd;
  }
  .table {
    background-color: #fff;
  }
  .row {
    margin-bottom: 20px;
  }
  .form {
    width: 450px;
    margin: 0 auto;
    padding: 20px 0;
    align-items: right;
  }
  .table {
    display: flex;
  }

  .label {
    line-height: 40px;
  }
  .button {
    width: 110px;
    height: 36px;
    background: rgba(0, 153, 255, 1);
    border-radius: 4px;
    margin-top: 30px;
    margin-bottom: 30px;
    text-align: center;
  }
  .button:hover {
    background: rgba(46, 172, 255, 1);
  }

  .notice {
    font-size: 13px;
    color: #666;
  }
}
</style>
